/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_How_It_WorksInputs */

const en_directory_vibebids_how_it_works = /** @type {(inputs: Directory_Vibebids_How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How VibeBids works`)
};

const zh_directory_vibebids_how_it_works = /** @type {(inputs: Directory_Vibebids_How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VibeBids 如何运作`)
};

/**
* | output |
* | --- |
* | "How VibeBids works" |
*
* @param {Directory_Vibebids_How_It_WorksInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_how_it_works = /** @type {((inputs?: Directory_Vibebids_How_It_WorksInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_How_It_WorksInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_how_it_works(inputs)
	return zh_directory_vibebids_how_it_works(inputs)
});
export { directory_vibebids_how_it_works as "directory.vibebids.how_it_works" }